module.exports = __webpack_public_path__ + "static/40-18c5e95b4b3b6cdb7628fb111973da20.png";